import React, { Suspense } from 'react'
import { PageErrorBoundary, RouteLoader } from '@appic/ui-components'

export function lazyRoute(Component: React.LazyExoticComponent<React.ComponentType>, label: string): React.ReactElement {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<RouteLoader label={label} />}>
        <Component />
      </Suspense>
    </PageErrorBoundary>
  )
}
